// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__19tF4","buttons":"RemoveExpirationActionButtons_buttons__2Jba5"};